import React from 'react';
import { styled } from '@mui/material';

import { ResourceChip, Stack } from 'shell/components';
import { downloadFileFromURL, getAbsoluteURL, getS3FileURL } from 'utils/helper';
import { useSnackbar } from 'contexts/snackbar';

const ResourceSection = ({ disabled, isInstructor = false, resourceList, deleteFile }) => {
    const { message } = useSnackbar();

    const handleSelect = ({ key }, resource) => {
        switch (key) {
            case 'download': {
                return downloadFileFromURL(getS3FileURL(resource.data), resource.data.name);
            }
            case 'delete': {
                return deleteFile(resource.id);
            }
            case 'visit':
                return downloadFileFromURL(getAbsoluteURL(resource.url));
            case 'copy':
                navigator.clipboard.writeText(getAbsoluteURL(resource.url));
                return message.success('Link copied to clipboard.');

            default:
                return;
        }
    };

    return (
        <CustomStack disabled={disabled} spacing={2}>
            <Stack sx={{ flexFlow: 'wrap' }} spacing={2}>
                {resourceList
                    ?.filter((resource) => resource.active)
                    .map((resource) => (
                        <Stack key={resource.id} alignItems={'center'} spacing={2} sx={{ width: '100%' }}>
                            <ResourceChip
                                options={[
                                    ...(resource.type === 'file'
                                        ? [{ key: 'download', value: 'Download' }]
                                        : [
                                              { key: 'visit', value: 'Visit Link' },
                                              { key: 'copy', value: 'Copy Link' },
                                          ]),
                                    ...(isInstructor ? [{ key: 'delete', value: 'Delete' }] : []),
                                ]}
                                resource={resource}
                                size={'small'}
                                type={resource.type}
                                onSelect={(option) => handleSelect(option, resource)}
                            />
                        </Stack>
                    ))}
            </Stack>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ disabled }) => {
    return {
        width: '100%',
        ...(disabled && {
            opacity: 0.5,
        }),
    };
});

export default ResourceSection;
